/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GmailAccountStatus } from './GmailAccountStatus';
import {
    GmailAccountStatusFromJSON,
    GmailAccountStatusFromJSONTyped,
    GmailAccountStatusToJSON,
    GmailAccountStatusToJSONTyped,
} from './GmailAccountStatus';

/**
 * Current Gmail connection status for the authenticated user
 * @export
 * @interface GmailStatusResponse
 */
export interface GmailStatusResponse {
    /**
     * Whether the user has a connected Gmail account
     * @type {boolean}
     * @memberof GmailStatusResponse
     */
    connected: boolean;
    /**
     * The connected Gmail account, or null if the user has no active connection
     * @type {GmailAccountStatus}
     * @memberof GmailStatusResponse
     */
    account: GmailAccountStatus | null;
    /**
     * Plain-text compose signature for the default Gmail send-as alias (if configured)
     * @type {string}
     * @memberof GmailStatusResponse
     */
    composeSignatureText?: string | null;
    /**
     * HTML compose signature for the default Gmail send-as alias (if configured)
     * @type {string}
     * @memberof GmailStatusResponse
     */
    composeSignatureHtml?: string | null;
}

/**
 * Check if a given object implements the GmailStatusResponse interface.
 */
export function instanceOfGmailStatusResponse(value: object): value is GmailStatusResponse {
    if (!('connected' in value) || value['connected'] === undefined) return false;
    if (!('account' in value) || value['account'] === undefined) return false;
    return true;
}

export function GmailStatusResponseFromJSON(json: any): GmailStatusResponse {
    return GmailStatusResponseFromJSONTyped(json, false);
}

export function GmailStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GmailStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'connected': json['connected'],
        'account': GmailAccountStatusFromJSON(json['account']),
        'composeSignatureText': json['composeSignatureText'] == null ? undefined : json['composeSignatureText'],
        'composeSignatureHtml': json['composeSignatureHtml'] == null ? undefined : json['composeSignatureHtml'],
    };
}

export function GmailStatusResponseToJSON(json: any): GmailStatusResponse {
    return GmailStatusResponseToJSONTyped(json, false);
}

export function GmailStatusResponseToJSONTyped(value?: GmailStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'connected': value['connected'],
        'account': GmailAccountStatusToJSON(value['account']),
        'composeSignatureText': value['composeSignatureText'],
        'composeSignatureHtml': value['composeSignatureHtml'],
    };
}

